<template>
  <div>
    <b-loading :active.sync="loadingInicial" />
    <div class="w-full flex justify-between items-start">
      <Lynx-Title text="Procurações" />
      <Lynx-Button
        text="Adicionar procuração"
        class="mb-4"
        icon="Plus"
        @click.native="openCreateModal"
        size="small"
        icon-size="3"
      />

      <v-btn
        color="#031127"
        style="border-radius: 25px"
        dark
        small
        @click.native="fetchProcuracao"
      >
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </div>
    <v-row>
      <v-col cols="12" md="3" lg="3">
        <Lynx-Label label="Digite Id / Nome / Razão Social" />

        <label class="flex flex-col w-full">
          <input
            class="border-primary-200 bg-white px-2 border-l-4 border-solid rounded py-1 w-full transition focus:shadow focus:border-r-4 font-light"
            v-model="payers_id"
            v-on:keyup.enter="fetchProcuracao"
          />
        </label>
      </v-col>

      <v-col cols="12" md="3" lg="3">
        <Lynx-Label label="Selecione tipo" />
        <treeselect
          :multiple="false"
          :options="[
            { id: 0, label: 'Todos' },
            { id: 'cliente', label: 'Cliente' },
            { id: 'empresa', label: 'Empresa' },
          ]"
          placeholder="Selecione tipo"
          v-model="filtros.payer_type"
        />
      </v-col>

      <v-col cols="12" md="3" lg="3">
        <Lynx-Label label="Seleciona um período" />
        <b-datepicker
          v-model="filtros.data"
          placeholder="Seleciona um período"
          :date-parser="(date) => new Date(date)"
          :month-names="monthNames"
          :day-names="dayNames"
          :years-range="[-3, 3]"
          range
        >
          <b-button
            label="Clear"
            type="is-danger"
            icon-left="close"
            outlined
            @click="filtros.data = null"
          />
        </b-datepicker>
      </v-col>

      <v-col cols="12" md="3" lg="3">
        <Lynx-Label label="Carteiras" />
        <treeselect
          :multiple="true"
          :options="lista_carteiras"
          placeholder="Selecione as carteiras..."
          v-model="filtros.carteiras"
        />
      </v-col>
    </v-row>
    <v-row class="justify-between">
      <v-col cols="12" md="4" lg="3">
        <Lynx-Label label="Status procuração" />
        <treeselect
          :multiple="false"
          :options="lista_status"
          placeholder="Selecione o status..."
          v-model="filtros.status"
        />
      </v-col>

      <v-col class="flex justify-end" cols="12" md="4" lg="3">
        <Lynx-Button
          text="Relatorio Procuração"
          class="mb-4"
          style="margin-top: 32px"
          @click.native="gerarRelatorio()"
          size="small"
          icon-size="3"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12" lg="12">
        <b-table
          :data="lista_procuracao"
          hoverables
          :loading="loading"
          backend-pagination
          paginated
          @page-change="onPageChange"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
          :total="pagination.total"
          :current-page="pagination.current_page"
          :per-page="pagination.per_page"
          class="w-full pb-8"
        >
          <template slot-scope="props">
            <b-table-column label="ID" field="payer_id">
              {{ props.row.payer_id }}
            </b-table-column>
            <b-table-column field="payer_type">
              <Icon-User v-if="props.row.payer_type === 'cliente'" />
              <Icon-Company v-if="props.row.payer_type === 'empresa'" />
            </b-table-column>
            <b-table-column label="Nome" field="nome">
              {{ props.row.nome }}
            </b-table-column>

            <b-table-column field="carteiras" label="Carteiras">
              <p v-for="(it, index) in props.row.carteiras" :key="index">
                {{ it.nome }}
              </p>
            </b-table-column>
            <b-table-column field="status" label="Status">
              <b-tag :type="props.row | statusType">{{
               lista_status.find((status) => status.id === props.row.status).label
              }}</b-tag>
            </b-table-column>
            <b-table-column label="Data de Vencimento" field="data_vencimento">
              {{
                !props.row.data_vencimento
                  ? "sem data"
                  : moment(props.row.data_vencimento).format("DD/MM/YYYY")
              }}
            </b-table-column>
            <b-table-column label="Ações">
              <div class="flex text-sm items-center">
                <a
                  href="#"
                  class="mr-4 bg-primary-600 rounded-full p-2"
                  @click.prevent="openEditModal(props.row)"
                >
                  <Icon-Edit class="text-neutral-100" size="4" />
                </a>
                <a
                  href="#"
                  class="bg-error-base rounded-full p-2"
                  @click.prevent="deleteProcuracao(props.row.id)"
                >
                  <Icon-Trash class="text-neutral-100" size="4" />
                </a>
                  <Logs v-if="props.row.activities" :logs="props.row.activities" :loading="loading" />

              </div>
            </b-table-column>
          </template>
          <template #empty>
            <Not-Found-Data text="Nenhum Procuracao registrado" />
          </template>
        </b-table>
      </v-col>
    </v-row>
    <b-modal :active.sync="editModal" v-if="editModal" >
      <Edit-Procuracao
        :procuracao="currentProcuracao"
        @edit-procuracao="onEditProcuracao"
      />
    </b-modal>
    <b-modal :active.sync="createModal" v-if="createModal" >
      <Edit-Procuracao @create-procuracao="onCreateProcuracao" />
    </b-modal>
  </div>
</template>

<script>
import {
  indexProcuracaoRequest,
  destroyProcuracaoRequest,
} from "@/services/requests/procuracao";

import EditProcuracao from "@/views/empresas/procuracao/Edit";
// import CreateProcuracao from "@/views/empresas/procuracoes/Create";
import NotFoundData from "@/components/layouts/NotFoundData";
import moment from "moment";
import { monthNames, dayNames } from "@/utils/utils";
import Logs from "@/views/logs/Logs";
import Treeselect from "@riophae/vue-treeselect";
import { mapGetters } from "vuex";

export default {
  name: "ProcuracaoIndex",
  components: { EditProcuracao, NotFoundData, Treeselect,Logs },
  data() {
    return {
      monthNames,
      dayNames,
      moment,
      loading: false,
      loadingInicial: false,
      createModal: false,
      editModal: false,
      procuracoes: {
        data: [],
        pagination: {
          current_page: 1,
          per_page: 10,
          total: 0,
        },
      },
      currentProcuracao: null,
      carteira: null,
      carteiras: [],
      status_procuracao: null,
      payers_id: null,
      lista_status: [
        { id: 0, label: "Todos" },
        { id: 1, label: "Finalizado" },
        { id: 2, label: "Normal" },
        { id: 3, label: "Próximo do vencimento" },
        { id: 4, label: "Vencido" },
      ],
      

      filtros: {
        page: 1,
        perPage: 10,
        empresa_id: null,
        carteiras: null,
        status: null,
        payer_id: null,
        payer_type: null,
      },
      perPageOptions: [10, 50, 100],
      current_page: 1,
    };
  },
  filters: {
    statusType: (val) => {
      if (val.status === 1 || val.status === 2){
        return "is-success";
      }

      if (val.status === 4) {
        return "is-danger";
      }
      if (val.status === 3) {
        return "is-warning";
      }
      if (val.status === 5) {
        return "is-primary";
      }
      return "default";
    },
  },
  watch: {
    "filtros.perPage"() {
      this.fetchProcuracao();
    },
    current_page() {
      this.filtros.page = this.current_page;
      this.fetchProcuracao();
    },
  },
  computed: {
    ...mapGetters(["getToken"]),

    lista_carteiras() {
      //  return this.$store.state.carteira.lista_carteiras;
      let carteira = Object.values(this.$store.state.carteira.lista_carteiras);
      let data = [{ id: 0, label: "todas" }];
      for (let i = 0; i < carteira.length; i++) {
        data.push({ id: carteira[i].id, label: carteira[i].nome });
      }
      return data;
    },
    lista_procuracao() {
      return this.procuracoes.data;
    },
    pagination() {
      return this.procuracoes.pagination;
    },
  },

  methods: {
    listar_carteiras() {
      this.$store.dispatch("carteira/listar_carteiras");
    },

    fetchProcuracao() {
      this.loading = true;

      if (this.payers_id) {
        this.filtros.payer_id = this.payers_id.split(",");
      } else {
        this.filtros.payer_id = null;
      }

      const { filtros } = this;

      const filtrosPreenxidos = Object.keys(filtros).reduce((acc, key) => {
        if (this.filtros[key] !== 0) {
          acc[key] = this.filtros[key];
        }
        return acc;
      }, {});

      indexProcuracaoRequest(filtrosPreenxidos)
        .then((res) => (this.procuracoes = res.data))
        .finally(() => (this.loading = false));
    },
    openCreateModal() {
      this.createModal = true;
    },
    openEditModal(currentProcuracao) {
      this.currentProcuracao = currentProcuracao;
      this.editModal = true;
    },
    onEditProcuracao() {
      this.fetchProcuracao();
      this.editModal = false;
    },
    onCreateProcuracao() {
      this.fetchProcuracao();
      this.createModal = false;
    },
    deleteProcuracao(id) {
      this.$buefy.dialog.confirm({
        message: "Deseja realmente excluir o alvará desta empresa?",
        confirmText: "Excluir",
        cancelText: "Cancelar",
        type: "is-danger",
        onConfirm: () => this.onDeleteProcuracao(id),
      });
    },
    onDeleteProcuracao(id) {
      destroyProcuracaoRequest(id)
        .then(() => {
          this.$snack.success("Procuração excluido com sucesso");
          this.fetchProcuracao();
        })
        .catch(() => this.$snack.error("Não foi possivel excluir o alvará"));
    },
    gerarRelatorio() {
    
      const { filtros } = this;

      const filtrosPreenxidos = Object.keys(filtros).reduce((acc, key) => {
        if (this.filtros[key] !== 0 && this.filtros[key] !== null) {
          acc[key] = this.filtros[key];
        }
        return acc;
      }, {});

      let form = {
        ...filtrosPreenxidos,
        data:
          this.filtros.data != null
            ? this.filtros.data.map((date) => date.toISOString())
            : null,
      };

      // Constrói a string de parâmetros, tratando corretamente arrays
      const parametrosString = Object.entries(form)
        .flatMap(([chave, valor]) => {
          if (Array.isArray(valor)) {
            return valor.map(
              (item) =>
                `${encodeURIComponent(chave)}[]=${encodeURIComponent(item)}`
            );
          } else {
            return `${encodeURIComponent(chave)}=${encodeURIComponent(valor)}`;
          }
        })
        .join("&");

      const baseUrl =`${process.env.VUE_APP_API_URL}/empresas/procuracao-relatorio`

      // Monta a URL completa incluindo o token e abre em uma nova aba
      const urlCompleta = `${baseUrl}?${parametrosString}&token=${this.getToken}`;
      window.open(urlCompleta, "_blank");


    },

    onPageChange(page) {
      this.current_page = page;
    },
  },
  beforeMount() {
    this.fetchProcuracao();
    this.listar_carteiras();
  },
};
</script>
